/**
 * 统计数据卡片组件
 * 显示今日创建、完成、退票等统计数据
 */
<template>
  <div class="stats-card">
    <div class="stat-item" v-for="item in statsItems" :key="item.key" :class="item.type">
      <i :class="item.icon"></i>
      <span class="stat-label">{{ item.label }}</span>
      <strong class="stat-value">{{ formatNumber(item.value) }}</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatsCard',
  props: {
    stats: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    statsItems() {
      return [
        {
          key: 'create',
          type: 'stat-create',
          icon: 'el-icon-document-add',
          label: '今日创建',
          value: this.stats.orderCreatNum || 0
        },
        {
          key: 'complete',
          type: 'stat-complete',
          icon: 'el-icon-circle-check',
          label: '今日完成',
          value: this.stats.orderFinishNum || 0
        },
        {
          key: 'refund',
          type: 'stat-refund',
          icon: 'el-icon-refresh-left',
          label: '今日退票',
          value: this.stats.orderRefundNum || 0
        }
      ];
    }
  },
  methods: {
    formatNumber(num) {
      if (!num) return '0';
      return num.toLocaleString();
    }
  }
};
</script>

<style lang="less" scoped>
.stats-card {
  display: flex;
  align-items: center;
  gap: 20px;

  .stat-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    background: #f5f7fa;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    i {
      font-size: 16px;
    }

    .stat-label {
      font-size: 12px;
      color: #909399;
    }

    .stat-value {
      font-size: 16px;
      font-weight: 600;
    }

    &.stat-create {
      background: rgba(43, 119, 255, 0.1);
      i, .stat-value { color: #2B77FF; }
    }

    &.stat-complete {
      background: rgba(103, 194, 58, 0.1);
      i, .stat-value { color: #67C23A; }
    }

    &.stat-refund {
      background: rgba(230, 162, 60, 0.1);
      i, .stat-value { color: #E6A23C; }
    }
  }
}
</style>
